import React from "react";

import BoardFeature from "../features/board";

function BoardPage(props) {
  return <BoardFeature {...props} />;
}

export default BoardPage;
